import React, { useEffect, useState } from "react";
import AppNavBarWithBackAction from "../../modules/AppNavBarWithBackAction";
import api_requests from "../../resources/api_requests";
import TicketHistoryItem from "./TicketHistoryItem";
import TicketHistoryItemContentLoader from "./TicketHistoryItemContentLoader";
import _ from "lodash";

const TicketHistory = () => {
  const [isLoading, setLoading] = useState(false);
  const [tickets, setTickets] = useState([]);

  async function fetchTickets() {
    setLoading(true);
    try {
      const response = await api_requests.get_igm_tickets();

      console.log("Ticket History response", response);

      //MARK::- HANDLE ERROR HERE
      setTickets(response.data);
    } catch (error) {
      //MARK::- HANDLE ERROR HERE
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <div className="px-6 mt-10">
      <AppNavBarWithBackAction title="Ticket History" />
      <div className="mt-8">
        <div className="space-y-5">
          {isLoading ? (
            <>
              <TicketHistoryItemContentLoader />
              <TicketHistoryItemContentLoader />
              <TicketHistoryItemContentLoader />
              <TicketHistoryItemContentLoader />
            </>
          ) : (
            _.map(tickets, ticket => (
              <TicketHistoryItem key={ticket.ticket_id} ticket={ticket} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketHistory;
